"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonMobile = exports.button = exports.imageBackground = exports.bodyText = exports.svgContainer = exports.buttonText = exports.buttonMobileText = void 0;
const PreviewerContext_1 = require("../../../PreviewerContext");
exports.buttonMobileText = {
    color: PreviewerContext_1.PreviewerTheme.colors.white,
    fontSize: 13,
};
exports.buttonText = Object.assign(Object.assign({}, exports.buttonMobileText), { display: 'flex', width: '100%', height: '100%', textAlign: 'center', alignItems: 'center', justifyContent: 'center' });
exports.svgContainer = {
    width: 100,
    height: 90,
    minHeight: 50,
    maxHeight: 90,
};
exports.bodyText = Object.assign(Object.assign({}, exports.buttonText), { marginBottom: 10, width: 230, height: 50, maxWidth: 230, minWidth: 180 });
exports.imageBackground = {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    minWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
};
exports.button = {
    backgroundColor: PreviewerContext_1.PreviewerTheme.colors.secondary.main,
    width: 160,
    height: 45,
    borderRadius: 50,
};
exports.buttonMobile = Object.assign(Object.assign({}, exports.button), { textAlign: 'center', alignItems: 'center', justifyContent: 'center' });
